import {h} from 'preact';

function isAllowedToAddAssociatedUsers() {
	const institutionType = document.querySelector('#institutionType').textContent.trim().toUpperCase()
	return institutionType === 'INSTITUTION'
}

export default function IpRangeEnablerAssociatedUsers({checked, handleIpRangeEnablerChange, error}) {
	const bpid = window.BPID;
	const helpAndContactHref = `https://librarian.springernature.com/help-contact?activeBpId=${bpid}`;
	return isAllowedToAddAssociatedUsers() ? (<div className="u-margin-top-default c-card__interior-left">
			<h3>Automatic association</h3>
			{/*
		<div class="c-inputgroup">
			<input
				type="checkbox"
				id="iprange-enabler-associated-users"
				class="c-inputgroup__checkbox"
				checked={checked}
				onChange={handleIpRangeEnablerChange}
			/>
			<label for="iprange-enabler-associated-users" class="c-inputgroup__title c-inputgroup__title--inline">Yes,
				create associations automatically</label>
			{error && <p class="c-inputgroup__validation-text c-inputgroup__validation-text--errored">
				<svg
					
					aria-hidden="true"
					width="16"
					height="16"
					class="c-inputgroup__validation-icon c-inputgroup__validation-icon--errored"
				>
					<use xlinkHref="#icon-error" />
				</svg>
				<span>Error: We couldn't update the Setting!</span>
			</p>}
		</div>
		<p>
			An association will be created if a person is using an IP address from your ranges when they sign up for a
			new Springer Nature account via SpringerLink.
		</p>
*/}
		<aside
			class="
				eds-c-status-message eds-c-status-message--info u-margin-bottom-default
			"
		><div class="eds-c-status-message__content-icon">
			<svg
				
				aria-hidden="true"
				class="eds-c-status-message__icon"
				width="24"
				height="24"
				role="img"
				aria-label="info">
				<use href="/static/img/svg-sprite.svg#info"></use>
			</svg>
		</div>
				<div class="eds-c-status-message__message" tabindex="-1">
					We have removed the ability to have users automatically be associated.
					You can still associate users via the invite form above.
					If the automatic association was very valuable to you,&nbsp;<a href="https://www.research.net/r/NGDHL5G"
						class="ext-link-icon"
						rel="noopener"> let us know why in our short survey </a> so that we can design new access methods that fit your organisation.
			</div>
		</aside>


		</div>) :
		(<div/>);
}
